/* @jsxImportSource react */

import { type EnergyEfficiencyFlagProps } from '@packages/shared/src/ui/EnergyEfficiencyFlag/EnergyEfficiencyFlag';
import type { EfficiencyFlagOverlay } from '@packages/modules/src/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { EfficiencyFlagOverlayDialog } from '@packages/modules/src/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { type TireEfficiencyFlagSpecificProps } from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';
import { EnergyEfficiencyFlagLocalized } from '../EfficiencyFlagLocalized/EnergyEfficiencyFlagLocalized/EnergyEfficiencyFlagLocalized';
import { TireEfficiencyFlagLocalized } from '../EfficiencyFlagLocalized/TireEfficiencyFlagLocalized/TireEfficiencyFlagLocalized';
import { type Datasheet, ProductCardV2DatasheetLink } from './ProductCardV2.DatasheetLink';

export type ProductCardV2EnergyEfficiencyFlagsLegacyProps = {
  flags: ReadonlyArray<
    (EnergyEfficiencyFlagProps | TireEfficiencyFlagSpecificProps) & {
      overlay?: EfficiencyFlagOverlay;
    }
  >;
  datasheets: readonly Datasheet[];
};

export const ProductCardV2EnergyEfficiencyFlagsLegacy = ({
  flags,
  datasheets,
}: ProductCardV2EnergyEfficiencyFlagsLegacyProps) => (
  <div className="flex gap-1">
    <div className="flex flex-col flex-wrap items-start gap-1">
      {flags.map(({ overlay, ...flagProps }, index) => (
        <EfficiencyFlagOverlayDialog key={overlay?.title ?? index} overlay={overlay}>
          {!('type' in flagProps) && <EnergyEfficiencyFlagLocalized {...flagProps} />}
          {'type' in flagProps && <TireEfficiencyFlagLocalized {...flagProps} />}
        </EfficiencyFlagOverlayDialog>
      ))}
    </div>
    <div className="flex flex-col gap-1">
      {datasheets.map((datasheet, index) => (
        <ProductCardV2DatasheetLink key={datasheet.url ?? index} datasheet={datasheet} />
      ))}
    </div>
  </div>
);
